import { Button, CircularProgress, Dialog, DialogContent } from '@mui/material'
import React from 'react'
import { CalQtySack } from '../services/stockService'

export default function ConfirmDialogTransfer({ open, setOpen, rows, handleAdd, loadingSubmit }) {
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            maxWidth='xl'
        >
            <DialogContent>
                <div class="d-flex row align-items-center mb-4">
                    <div class="col-12">
                        <label style={{
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            color: '#3364af',
                        }}>
                            รายการโอนเมล็ดพันธุ์
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 table-responsive-sm ">
                        <table class="table table-borderless  ">
                            <thead>
                                <tr>
                                    <th scope="col " class="text-center">ที่</th>
                                    <th scope="col " class="text-center">เมล็ดพันธุ์</th>
                                    <th scope="col " class="text-center">ชั้นพันธุ์</th>

                                    <th scope="col " class="text-center">ฤดู</th>
                                    <th scope="col " class="text-center">ชนิดข้าว</th>
                                    <th scope="col " class="text-center">สารเคมี</th>
                                    <th scope="col " class="text-center"> ปีที่ผลิต</th>

                                    <th scope="col " class="text-center">ล็อตที่</th>
                                    <th scope="col " class="text-center">จำนวน (กระสอบ)</th>
                                    <th scope="col " class="text-center">ปริมาณ</th>
                                    <th scope="col " class="text-center">หน่วย</th>
                                    <th scope="col " class="text-center" >โรงเก็บ</th>
                                    <th scope="col " class="text-center">ต้นทุนการผลิต</th>
                                    <th scope="col " class="text-center">โรงเก็บที่รับเข้า</th>
                                </tr>
                            </thead>
                            <tbody class="">
                                {rows?.map((creds, i) => (
                                    <tr>
                                        <td class="text-center">{i + 1}.</td>
                                        <td class="text-center">{creds?.ItemNo?.ItemName}</td>
                                        <td class="text-center">{creds?.ItemNo?.Option2}</td>
                                        <td class="text-center">
                                            <span style={{ fontWeight: 'bold', color: creds?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown' }}>{creds?.ItemNo?.Season} </span>
                                        </td>
                                        <td class="text-center">{creds?.ItemNo?.Option1}</td>
                                        <td class="text-center">{creds?.ItemNo?.Chemical}</td>
                                        <td class="text-center">{creds?.Year}</td>
                                        <td class="text-center">{creds?.Lot?.Lot}</td>
                                        <td class="text-center">{CalQtySack(creds?.ItemNo?.Option2, creds.Qty.toString().replaceAll(',', '')).toLocaleString()}</td>
                                        <td class="text-center">{creds?.Qty.toLocaleString()}</td>
                                        <td class="text-center">{creds?.UnitNo?.UnitName || creds?.UnitName}</td>
                                        <td class="text-center">{ creds?.WarehouseNo?.WarehouseName && creds?.ZoneNo?.ZoneName ? `${creds?.WarehouseNo?.WarehouseName} / ${creds?.ZoneNo?.ZoneName}` : ''}</td>
                                        <td class="text-center">{parseFloat(creds?.Lot?.CostPrice || 0).toFixed(2)
                                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                        <td class="text-center">{creds?.WarehouseNoTo ? `${creds?.WarehouseNoTo?.WarehouseNo?.WarehouseName}/${creds?.WarehouseNoTo?.ZoneName}` : '-'}</td>
                                    </tr>
                                ))}
                                
                            </tbody>
                        </table >
                    </div >


                </div >
                <div class="row mt-4">

                    <div class="col-12 text-end">
                        <Button onClick={() => setOpen(false)} variant='outlined' sx={{ width: "150px", marginRight: '20px' }}>ยกเลิก</Button>
                        <Button disabled={loadingSubmit} onClick={() => handleAdd('Y')} variant='contained' sx={{ width: "150px", marginRight: '20px' }}>{loadingSubmit ? <CircularProgress size={'24px'} color="inherit" /> : 'ยืนยันการทำรายการ'}</Button>
                    </div>
                </div>
            </DialogContent >
        </Dialog >
    )
}
